import { ErrorEvent } from "@sentry/remix";

export const isEasySizeTypeError = (errorEvent: ErrorEvent) =>
  errorEvent.exception?.values?.some(
    (exception) =>
      exception.type === "TypeError" &&
      (exception.value ===
        "Cannot read properties of null (reading 'length')" ||
        exception.value === "null is not an object (evaluating 'a.length')" ||
        exception.value === "a is null") &&
      exception.stacktrace?.frames?.some((stackFrame) =>
        stackFrame.filename?.match(
          "https://webapp.easysize.me/web_app_v1.0/js/easysize.js",
        ),
      ),
  );
